<template>
    <div class="report">
        <report-filters
            :report-type="reportType"
            :filters="rawFilters"
            :get-filters-fetch-dispatch="getFiltersFetchDispatch"
            :set-filters-fetch-dispatch="setFiltersFetchDispatch"
            :get-report-csv-dispatch="getReportCsvDispatch"
            :get-report-table-dispatch="getReportTableDispatch"
        />
        <report-table
            :data="rawData"
        />
        <component-pagination
            v-if="paginationHasPages"
            :pagination="rawPagination"
            @emit-page="setFilterPage"
        />
    </div>
</template>

<script>
import ReportFilters from '@/components/ebs/reports/ReportFilters'
import ReportTable from '@/components/ebs/reports/ReportTable'
import ComponentPagination from '@/components/default/shared/ComponentPagination'

export default {
  name: 'base-report',
  components: { ComponentPagination, ReportTable, ReportFilters },
  data () {
    return {
      // data parameters for request
      page: 1,
      pageSize: 12,
      query: '',
      sort: '',
      sortBy: ''
    }
  },
  props: {
    reportType: {
      type: String,
      required: true
    },
    getPaginationGetter: {
      type: String
    },
    getFiltersGetter: {
      type: String
    },
    getFiltersDispatch: {
      type: String
    },
    setFiltersFetchDispatch: {
      type: String
    },
    getFiltersFetchDispatch: {
      type: String
    },
    getDataGetter: {
      type: String
    },
    getDataDispatch: {
      type: String
    },
    getReportTableDispatch: {
      type: String
    },
    getReportCsvDispatch: {
      type: String
    }
  },
  computed: {
    rawFilters () {
      return this.$store.getters[this.getFiltersGetter]
    },
    rawData () {
      return this.$store.getters[this.getDataGetter]
    },
    rawPagination () {
      return this.$store.getters[this.getPaginationGetter]
    },
    dispatchParams () {
      return this.page + this.pageSize + this.query
    },
    paginationHasPages () {
      return this.rawPagination.pageSize < this.rawPagination.totalResults
    }
  },
  methods: {
    setFilterResult (data) {
      this.outputItems = data
    },
    setFilterQuery (value) {
      this.setFilterPage(1)
      this.query = value
    },
    setFilterPage (value) {
      this.page = value
    },
    getItems () {
      const page = this.page
      const pageSize = this.pageSize
      const query = encodeURIComponent(this.query)
      const sort = this.sort
      const sortBy = this.sortBy

      let urlParams
      urlParams = (page || pageSize || query || sort || sortBy) ? '?' : ''
      urlParams += page ? `page=${page}` : ''
      urlParams += pageSize && page ? '&' : ''
      urlParams += pageSize ? `pageSize=${pageSize}` : ''
      urlParams += query && (page || pageSize) ? '&' : ''
      urlParams += query ? `filter=${query}` : ''
      urlParams += sort && (page || pageSize || query) ? '&' : ''
      urlParams += sort ? `sort=${sort}` : ''
      urlParams += sortBy && (page || pageSize || query || sort) ? '&' : ''
      urlParams += sortBy ? `sortBy=${sortBy}` : ''

      this.$eventBus.$emit(`start-loading-report-${this.reportType}`)
      this.$store.dispatch(this.getDataDispatch, this.reportType + urlParams)
    }
  },
  watch: {
    dispatchParams () {
      this.getItems()
      this.$emit('emit-dispatch')
    }
  }
}
</script>
<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/report";
</style>
